export const APP = {
  ROUTES: {
    ROOT: '/',
    PLAN: '/plan',
    SETTINGS: '/settings',
    PROJECTS: '/projects',
    PROJECT: '/projects/:projectId',
    PROJECT_OVERVIEW: '/projects/:projectId/overview',
    PROJECT_DOCUMENTATIONS: '/projects/:projectId/documentations',
    PROJECT_STAGES: '/projects/:projectId/stages',
    PROJECT_CONTRACTORS: '/projects/:projectId/contractors',
    PROJECT_SHARES: '/projects/:projectId/shares',
  },
  PAGINATION: {
    DEFAULT: {
      page: 1,
      size: 20,
    },
    EMPTY: { page: 1, size: 20, totalItems: 0, totalPages: 0 },
  },
  EMPTY_FORM_PLACEHOLDER: '-',
  DEBOUNCE: 700,
};
